import type { LucideIcon } from "lucide-react";

export type V3LedgerQueueItem<Key extends string> = {
  key: Key;
  label: string;
  count: number;
  icon: LucideIcon;
};

/**
 * 正式台账状态带：紧跟控制栏、紧贴表头，统一紧凑密度与选中态。
 * 数量必须来自服务端全量口径，组件只负责呈现与切换。
 */
export function V3LedgerQueueBand<Key extends string>({ ariaLabel, items, value, onChange }: {
  ariaLabel: string;
  items: readonly V3LedgerQueueItem<Key>[];
  value: Key;
  onChange: (value: Key) => void;
}) {
  return <div className="v3-ledger-queue-band" aria-label={ariaLabel}>
    {items.map(({ key, label, count, icon: Icon }) => <button
      key={key}
      type="button"
      className={value === key ? "active" : ""}
      aria-pressed={value === key}
      onClick={() => onChange(key)}
    >
      <Icon size={15} aria-hidden />
      <span>{label}</span>
      <strong className="app-number">{count}</strong>
    </button>)}
  </div>;
}
